var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3446 34.6359C76.4743 35.5595 76.5761 37.1505 75.5719 38.1896L46.3789 68.3962C45.8595 68.9336 45.1151 69.2411 44.3334 69.2411C43.5516 69.2411 42.8072 68.9336 42.2878 68.3962L27.6913 53.2929C26.6871 52.2538 26.7889 50.6628 27.9186 49.7392C29.0483 48.8156 30.7782 48.9091 31.7824 49.9482L44.3334 62.935L71.4808 34.8449C72.485 33.8058 74.2149 33.7122 75.3446 34.6359Z",
    fill: "#0E8750"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 50,
    stroke: "#0E8750",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8fe24ac85dd428633f0c74751364f65c.svg";
export { ForwardRef as ReactComponent };